import { Button, Text } from "@chakra-ui/react";
import { getChatReactionValue } from "./ReactionsPopover";

export function ReactionButton({
  toggleReaction,
  reactionTypeId,
  userHasReacted,
  numberOfReactions,
}: {
  toggleReaction: (reactionId: number) => void;
  reactionTypeId: number;
  userHasReacted: boolean;
  numberOfReactions: number;
}) {
  return (
    <Button
      size="thin"
      onClick={() => toggleReaction(reactionTypeId)}
      fontSize="12px"
      fontWeight="400"
      p="4px 8px"
      borderRadius="100px"
      gap="4px"
      border="1px solid"
      borderColor={userHasReacted ? "blaze.300" : "transparent"}
    >
      {getChatReactionValue(reactionTypeId)}
      <Text color="dune.dune">{numberOfReactions}</Text>
    </Button>
  );
}
